'use client';
import { createContext, useContext } from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

const SelectionSetContext = createContext(null);
SelectionSetContext.displayName = 'SelectionSetContext';
const SelectionSetInputContext = createContext(void 0);
function useSelectionSetContext() {
    return useNonNullishContext(SelectionSetContext);
}
function useSelectionSetInputContext() {
    return useContext(SelectionSetInputContext);
}

export { SelectionSetContext, SelectionSetInputContext, useSelectionSetContext, useSelectionSetInputContext };
